var Alabama = "ألاباما";
var Alaska = "ألاسكا";
var Arizona = "أريزونا";
var Arkansas = "أركنساس";
var California = "كاليفورنيا";
var Colorado = "كولورادو";
var Connecticut = "كونيتيكت";
var Delaware = "ديلاوير";
var Florida = "فلوريدا";
var Georgia = "جورجيا";
var Hawaii = "هاواي";
var Idaho = "آيداهو";
var Illinois = "إلينوي";
var Indiana = "إنديانا";
var Iowa = "أيوا";
var Kansas = "كانساس";
var Kentucky = "كنتاكي";
var Louisiana = "لويزيانا";
var Maine = "مين";
var Maryland = "ماريلاند";
var Massachusetts = "ماساتشوستس";
var Michigan = "ميشيغان";
var Minnesota = "مينيسوتا";
var Mississippi = "ميسيسيبي";
var Missouri = "ميزوري";
var Montana = "مونتانا";
var Nebraska = "نبراسكا";
var Nevada = "نيفادا";
var Ohio = "أوهايو";
var Oklahoma = "أوكلاهوما";
var Oregon = "أوريغون";
var Pennsylvania = "بنسلفانيا";
var Tennessee = "تينيسي";
var Texas = "تكساس";
var Utah = "يوتا";
var Vermont = "فيرمونت";
var Virginia = "فرجينيا";
var Washington = "واشنطن";
var Wisconsin = "ويسكونسن";
var Wyoming = "وايومنغ";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "مقاطعة كولومبيا (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "نيوهامشير",
	"New Jersey": "نيوجيرسي",
	"New Mexico": "نيومكسيكو",
	"New York": "نيويورك",
	"North Carolina": "كارولينا الشمالية",
	"North Dakota": "داكوتا الشمالية",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "رود آيلاند",
	"South Carolina": "كارولينا الجنوبية",
	"South Dakota": "داكوتا الجنوبية",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "فيرجينيا الغربية",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
